export const localValidate = (formState) => {
  let errors = {};

  if (formState.password.trim() === '') {
    errors.password = 'Password is required';
  }

  return errors;
};

const ReLoginFormValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default ReLoginFormValidation;